import { render, staticRenderFns } from "./initial-validation-info.vue?vue&type=template&id=5f265122&scoped=true"
import script from "./initial-validation-info.vue?vue&type=script&lang=js"
export * from "./initial-validation-info.vue?vue&type=script&lang=js"
import style0 from "./initial-validation-info.vue?vue&type=style&index=0&id=5f265122&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f265122",
  null
  
)

export default component.exports